const getTimeFormat = (time) => {
    const timePeriod = time
    if (timePeriod >= 2629746000) {
        return 'month'
    } else if (timePeriod >= 604800000) {
        return 'week'
    } else if (timePeriod > 8640000) {
        return 'day'
    } else {
        return 'hour'
    }
}

const getSeconds = (start, end) => {
    const startDate = new Date(start).getTime()
    const endDate = new Date(end).getTime()
    const timePeriod = endDate - startDate
    return timePeriod
}

export {
    getTimeFormat,
    getSeconds
}
